<div class="contains-button">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate}} </span>
  </div>

  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]="objectChoosing.id_block? objectChoosing.id_block: objectChoosing.id_object">
    </app-position-out-config>

    <app-width-height-config [device]="device" [elementChoosing]="objectChoosing" [width]="class[objectChoosing.resize_field]['width']" [height]="class[objectChoosing.resize_field]['height']"
      (changeWidthHeight)="changeWidthHeight($event)">
    </app-width-height-config>
    <ul nz-menu nzMode="inline" >
      <!-- Cấu hình thông số cơ bản của button-->
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>

      <li nz-submenu nzTitle="{{'dinh_dang_van_ban' | translate}}" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class" [config]="config"
          [staticdata]="staticdata" [textContentClass]="class['radio-payment-method__label']" [textWrapperClass]="class['radio-payment-method__item']"
          (changeTextAlignConfig)="changeWidthHeight({width: width})">
        </app-text-format-config>
      </li>

      <li nz-submenu nzTitle="{{'mau_nut' | translate}}" [(nzOpen)]="openMap.menu3"
        (nzOpenChange)="openHandler('menu3')">
        <div class="color-pick mb-2">
          <span class="title w-50">{{'mau_nut' | translate}}</span>
          <input class="input-color w-50" type="button" 
            [cpOKButton]="true"
            [(colorPicker)]="class['radio-payment-method__radio']['accent-color']"
            [style.background]="class['radio-payment-method__radio']['accent-color']" 
            (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'" 
            [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
            [cpAddColorButton]="true" 
            [cpAddColorButtonText]="'them_mau' | translate"
            [cpPresetLabel]="'bang_mau_mau' | translate" 
            [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate" 
            [cpPresetColors]="themeService.themeColors"
            (cpPresetColorsChange)="themeService.presetColorsChange($event)" />
        </div>

        <div class="flex flex-col ">
          <div class="flex items-center justify-between mb-2">
            <p class="m-0 title-border">{{'kich_thuoc' | translate}}</p>
            <nz-input-number [nzMin]="0"  [nzStep]="1"
              [ngModel]="class['radio-payment-method__radio']['width'] | vhnumber" 
              (ngModelChange)="class['radio-payment-method__radio']['width'] = class['radio-payment-method__radio']['height'] = $event + 'px'"
              (nzBlur)="updateClass()" ></nz-input-number>
          </div>
          <div>
            <nz-slider [ngModel]="class['radio-payment-method__radio']['width'] | vhnumber" [nzMin]="0"
              [nzStep]="1"
              (ngModelChange)="class['radio-payment-method__radio']['width'] = class['radio-payment-method__radio']['height'] = $event+'px'; "
              (nzOnAfterChange)="updateClass()"></nz-slider>
          </div>
        </div>

        <div class="flex flex-col ">
          <div class="flex items-center justify-between mb-2">
            <p class="m-0 title-border" style="line-height: normal">{{'khoang_cach_ben_phai' | translate}}</p>
            <nz-input-number [nzMin]="0"  [nzStep]="1"
              [ngModel]="class['radio-payment-method__radio']['margin-right'] | vhnumber" 
              (ngModelChange)="class['radio-payment-method__radio']['margin-right'] = $event + 'px'"
              (nzBlur)="updateClass()" ></nz-input-number>
          </div>
          <div>
            <nz-slider [ngModel]="class['radio-payment-method__radio']['margin-right'] | vhnumber" [nzMin]="0"
              [nzStep]="1"
              (ngModelChange)="class['radio-payment-method__radio']['margin-right'] = $event+'px'; "
              (nzOnAfterChange)="updateClass()"></nz-slider>
          </div>
        </div>

        <div class="flex flex-col ">
          <div class="flex items-center justify-between mb-2">
            <p class="m-0 title-border" style="line-height: normal">{{'khoang_cach_ben_duoi' | translate}}</p>
            <nz-input-number [nzMin]="0"  [nzStep]="1"
              [ngModel]="class['radio-payment-method__item']['margin-bottom'] | vhnumber" 
              (ngModelChange)="class['radio-payment-method__item']['margin-bottom'] = $event + 'px'"
              (nzBlur)="updateClass()" ></nz-input-number>
          </div>
          <div>
            <nz-slider [ngModel]="class['radio-payment-method__item']['margin-bottom'] | vhnumber" [nzMin]="0"
              [nzStep]="1"
              (ngModelChange)="class['radio-payment-method__item']['margin-bottom'] = $event+'px'; "
              (nzOnAfterChange)="updateClass()"></nz-slider>
          </div>
        </div>
      </li>

      <li nz-submenu nzTitle="{{'thanh_phan' | translate}}" [(nzOpen)]="openMap.menu4"
        (nzOpenChange)="openHandler('menu4')">
        <!-- Danh sách các tabs -->
        <ul cdkDropList [style.height]="objectChoosing.staticdata.payment_methods.length <= 5 ? ' auto': '300px'"
          [style.min-height]="objectChoosing.staticdata.payment_methods.length <= 5?'auto': '300px'" class="example-list"
          (cdkDropListDropped)="cdkDropListDropped($event)">
          <li class="example-box row m-0"
            *ngFor="let item of objectChoosing.staticdata.payment_methods; index as i" cdkDrag>
            <div class="col p-0 d-flex align-items-center">
              <!-- icon nắm kéo -->
              <i class="bi bi-list example-handle mr-1" cdkDragHandle></i>
              <input type="text" nz-input 
                [title]="item.value"
                [(ngModel)]="item['label_' + functionService.selectedLanguageCode]"
                (blur)="item.edit = false; updateStaticData()" 
                (keydown.enter)="item.edit = false; updateStaticData()"/>
            </div>
          </li>
        </ul>
      </li>
      
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình object -->
  <div class="view-more" *ngIf="isViewAll">
    
  </div>
</div>